var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("headbox", {
        attrs: { title: "实名认证", bgColor: "#fff", isborder: "true" }
      }),
      _vm.forkpage
        ? _c("div", { staticClass: "cerbox" }, [
            _c("div", { staticClass: "tip" }, [
              _vm._v(
                " 尊敬的客户，根据《中华人民共和国网络安全法》及相关法律的规定，您需完成实名认证后方可交易。 "
              )
            ]),
            _c(
              "div",
              { staticClass: "rel tc imgboxlist" },
              [
                _c("van-uploader", { attrs: { "after-read": _vm.afterRead } }, [
                  _c("img", {
                    staticClass: "idCard",
                    attrs: { src: _vm.firstupsuccess, alt: "" }
                  }),
                  _c("img", {
                    staticClass: "photobox",
                    attrs: {
                      src: require("../../assets/images/photobox.png"),
                      alt: ""
                    }
                  })
                ])
              ],
              1
            ),
            _vm.isloading
              ? _c("div", [
                  _c("div", { staticClass: "bgfilter" }),
                  _c(
                    "div",
                    { staticClass: "tc loadingbox" },
                    [
                      _c("van-loading", { attrs: { size: "26px" } }, [
                        _c("span", { staticClass: "loadingfont" }, [
                          _vm._v("上传中...")
                        ])
                      ])
                    ],
                    1
                  )
                ])
              : _vm._e(),
            !_vm.usercenter
              ? _c("div", [
                  _c("h1", { staticClass: "tc" }, [_vm._v("拍摄身份证人像面")]),
                  _c("p", { staticClass: "detailsbox" }, [
                    _vm._v("● 建议拍摄时选择光线良好的环境")
                  ]),
                  _c("p", { staticClass: "detailsbox" }, [
                    _vm._v("● 请务必保证边框完整、字体清晰")
                  ])
                ])
              : _vm._e(),
            _vm.usercenter
              ? _c("div", [
                  _c("h1", { staticClass: "tc" }, [_vm._v("信息确认")]),
                  _c("div", { staticClass: "userbox" }, [
                    _c("b", [_vm._v("姓 名")]),
                    _c("i", [_vm._v(_vm._s(_vm.username))])
                  ]),
                  _c("div", { staticClass: "userbox" }, [
                    _c("b", [_vm._v("身份证号")]),
                    _c("i", [_vm._v(_vm._s(_vm.Idcard))])
                  ])
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "tc" },
              [
                _c(
                  "el-button",
                  { staticClass: "btn_yellow", on: { click: _vm.nextPage } },
                  [_vm._v("下一步")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      !_vm.forkpage
        ? _c("div", { staticClass: "cerbox" }, [
            _c("div", { staticClass: "tip" }, [
              _vm._v(
                " 请上传身份证信息，该项信息主要用于身份核对，我们将严格保证您的信息安全。 "
              )
            ]),
            _c(
              "div",
              { staticClass: "rel tc imgboxlist" },
              [
                _c(
                  "van-uploader",
                  { attrs: { "after-read": _vm.afterReadsecond } },
                  [
                    _c("img", {
                      staticClass: "idCard",
                      attrs: { src: _vm.upsuccess, alt: "" }
                    }),
                    _c("img", {
                      staticClass: "photobox",
                      attrs: {
                        src: require("../../assets/images/photobox.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ],
              1
            ),
            _vm.isloadingback
              ? _c("div", [
                  _c("div", { staticClass: "bgfilter" }),
                  _c(
                    "div",
                    { staticClass: "tc loadingbox" },
                    [
                      _c("van-loading", { attrs: { size: "26px" } }, [
                        _c("span", { staticClass: "loadingfont" }, [
                          _vm._v("上传中...")
                        ])
                      ])
                    ],
                    1
                  )
                ])
              : _vm._e(),
            !_vm.usercenterback
              ? _c("div", [
                  _c("h1", { staticClass: "tc" }, [_vm._v("拍摄身份证国徽面")]),
                  _c("p", { staticClass: "detailsbox" }, [
                    _vm._v("● 建议拍摄时选择光线良好的环境")
                  ]),
                  _c("p", { staticClass: "detailsbox" }, [
                    _vm._v("● 请务必保证边框完整、字体清晰")
                  ])
                ])
              : _vm._e(),
            _vm.usercenterback
              ? _c("div", [
                  _c("h1", { staticClass: "tc" }, [_vm._v("信息确认")]),
                  _c("div", { staticClass: "userbox" }, [
                    _c("b", [_vm._v("有效时间")]),
                    _c("i", [_vm._v(_vm._s(_vm.idCardTime))])
                  ])
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "tc" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn_yellow",
                    on: { click: _vm.nextPostData }
                  },
                  [_vm._v("下一步")]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }